/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('BoardDinghyBooking', BoardDinghyBooking);

    BoardDinghyBooking.$inject = ['$resource', 'DateUtils'];

    function BoardDinghyBooking ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingDate = DateUtils.convertDateTimeFromServer(data.bookingDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
